/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mic_Blocked_TitleInputs */



/**
* | output |
* | --- |
* | "Your browser is blocking the microphone" |
*
* @param {Practice_Session_Mic_Blocked_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_blocked_title = /** @type {((inputs?: Practice_Session_Mic_Blocked_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_Blocked_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je browser blokkeert de microfoon")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre navigateur bloque le micro")
	return /** @type {LocalizedString} */ ("Your browser is blocking the microphone")
});